module.exports = __webpack_public_path__ + "img/sudoku1.8594be4c.png";